import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['bulkInput', 'sensorField']

  declare readonly bulkInputTargets: HTMLInputElement[]
  declare readonly sensorFieldTargets: HTMLInputElement[]

  applyToAll (event: Event) {
    const button = event.currentTarget as HTMLElement
    const fieldName = button.dataset.fieldName

    if (!fieldName) {
      console.error('Missing data-field-name on button.')
      return
    }

    const bulkInput = this.bulkInputTargets.find(input =>
      input.dataset.fieldName === fieldName
    )

    if (bulkInput == null) {
      console.error(`Bulk input for '${fieldName}' not found`)
      return
    }

    const newValue = bulkInput.value
    this.sensorFieldTargets.forEach((field) => {
      if (field.dataset.fieldName === fieldName) {
        field.value = newValue
      }
    })
  }
}
